module.exports = __webpack_public_path__ + "static/media/bg-palm-spiral-2.cb46de53.svg";